import { auth } from './firebase';

// WHO CREATED THIS ROW.
//
// The security rules are about to grow a third layer: a role decides what you can see, a module
// admin decides what you can change across a module, and this decides what you can change because
// you are the one who entered it. That last layer needs a field, and it needs the SAME field
// everywhere -- a rule cannot try six spellings.
//
// The spellings already in the data are exactly why this exists:
//   created_by      Budget Control  an INITIAL, falling back to an email, falling back to 'Unknown'
//   created_by      Assessment      an email
//   submittedBy     Inventory       an accountId
//   enteredByEmail  Attendance      an email (submittedByEmail there is the SUBJECT, not the author)
//   issuedBy        Parent Notice   an initial
// None of those can be tested by a rule without knowing which module wrote the row.
//
// createdByEmail is the one the rules will read: always lower-cased, always the login address, per
// the platform rule that records store the email and display the personal particulars. The existing
// fields stay where they are -- several are shown on screen and a couple mean something different
// from "author" -- they just stop being load-bearing.
export function ownerStamp() {
  return {
    createdByEmail: (auth.currentUser?.email || '').trim().toLowerCase(),
    createdAt: new Date().toISOString(),
  };
}

// For edits. Deliberately separate: overwriting createdByEmail on every save would hand the row to
// whoever touched it last, which is the opposite of what the rules are being asked to enforce.
export function touchStamp() {
  return {
    updatedByEmail: (auth.currentUser?.email || '').trim().toLowerCase(),
    updatedAt: new Date().toISOString(),
  };
}

export function ownEmail() {
  return (auth.currentUser?.email || '').trim().toLowerCase();
}
